import React, { useEffect, useRef } from "react";

// Speech cards follow OralExamVoicePage's Session Log presentation.
export default function StudyBuddyTranscript({ entries }) {
  const logRef = useRef(null);
  const followRef = useRef(true);
  useEffect(() => {
    if (followRef.current && logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight;
  }, [entries]);
  return <section className="practice-transcript" aria-labelledby="practice-transcript-title">
    <h3 id="practice-transcript-title">Transcript</h3>
    <div className="practice-transcript-log" role="log" aria-labelledby="practice-transcript-title" aria-live="polite" aria-relevant="additions" tabIndex={0} ref={logRef} onScroll={(event) => {
      const log = event.currentTarget;
      followRef.current = log.scrollHeight - log.scrollTop - log.clientHeight <= 40;
    }}>
      {entries.length === 0 ? <p className="study-source">Finalized speech will appear here.</p> : entries.map((entry) => <div className={`practice-transcript-entry ${entry.speaker === "Study Buddy" ? "assistant" : "student"}`} key={entry.id}>
        <div className="practice-transcript-speaker"><b>{entry.speaker}:</b></div>
        <div className="practice-transcript-text">{entry.text}</div>
      </div>)}
    </div>
  </section>;
}
